import React, { Component, Fragment } from 'react';
import { AccordionDetails, AccordionSummary, Typography, Accordion, Box } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

class AccordionFilter extends Component{
    state = {
        view: this.props.new ? "new" : "list",
        expanded: false,
    }

    render(){
        const { expanded } = this.state;
        return(
            <Box p={1}>
                <Accordion expanded={expanded} onChange={() => this.setState({expanded: !expanded}) }>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panelSales-content"
                        id="panelSales-header"
                    >
                        <Typography>Filtres</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {this.props.children}
                    </AccordionDetails>
                </Accordion>                
            </Box>
        )
    }
}


export default AccordionFilter